import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import RoleList from '../components/Roles/RoleList';
import EditRole from '../components/Roles/EditRole';

const Roles = () => {
  return (
    <Routes>
      <Route path="/" element={<RoleList />} />
      <Route path="/edit/:id" element={<EditRole />} />
      <Route path="/edit" element={<EditRole />} />
    </Routes>
  )
}

export default Roles;